<template>
    <v-container>
        <v-row v-if="!editing">
            <v-toolbar dense flat color="transparent">
                <a @click="editValue" v-text="title" :class="classTitle" />
            </v-toolbar>
        </v-row>
        <v-row v-if="editing">
            <v-col>
                <v-card flat>
                    <v-card-text>
                        <v-text-field
                            :label="$t('packs.versions.attributes.name')"
                            v-if="editing"
                            v-model="editingValue"
                            single-line
                            counter="80"
                        ></v-text-field>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="editing = false" v-text="$t('buttons.cancel')" />
                        <v-btn color="success" text @click="changeAttribute" v-text="$t('buttons.save')" />
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: 'pack-label',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    props: {
        pack: {},
        version: {},
        allowEditing: {
            default: true,
        },
    },
    watch: {
        editing: function (e) {
            if (e) {
                this.editingValue = this.version.name;
            }
        },
    },
    computed: {
        title() {
            return 'Version ' + this.version.name;
        },
        classTitle() {
            return this.$vuetify.theme.dark ? 'blue-grey--text text--lighten-4' : 'blue-grey--text text--darken-4';
        },
    },
    methods: {
        ...mapActions(['updatePackVersion']),
        editValue() {
            if (this.allowEditing) {
                this.editing = true;
            }
        },
        async changeAttribute(value) {
            await this.updatePackVersion({
                pack_id: this.pack.id,
                id: this.version.id,
                name: this.editingValue,
            });

            this.editing = false;
            this.$emit('change-attribute-value');
        },
    },
};
</script>
